<template>
  <toggle-section
    v-if="section"
    :section="section.title"
    chevron-position="right"
    :has-padding="false"
    :is-open="isOpen"
    content-gray
    class="collapse-toggle-padding"
    :data-cy="section.title"
    @toggle="isOpen = !isOpen"
  >
    <template #titleSection>
      <h3 class="font-semibold text-headline">
        {{ section.title }}
      </h3>
    </template>
    <template #content>
      <div class="p-4">
        <div class="rounded-sm border bg-white">
          <div class="space-y-4 p-4">
            <template v-if="'title' in section.data[0]">
              <div
                v-for="(record, index) in section.data as DocumentRetrieval[]"
                :key="`section_${index}`"
                class="rounded-sm border bg-white"
              >
                <div class="border-b p-4 text-headline">
                  {{ record.title }}
                </div>
                <div class="space-y-4 p-4">
                  <value-row
                    v-for="item in record.data as RetrievalData[]"
                    :key="item.label"
                    :item="item"
                  />
                </div>
              </div>
            </template>
            <value-row
              v-for="item in section.data as RetrievalData[]"
              v-else
              :key="item.label"
              :item="item"
            />
          </div>
        </div>
      </div>
    </template>
  </toggle-section>
</template>

<script setup lang="ts">
import { ref } from "vue";

import ToggleSection from "@/components/ToggleSection.vue";
import ValueRow from "@/components/deals/dataServices/components/clear/documentRetrieval/ValueRow.vue";

import type {
  DocumentRetrieval,
  RetrievalData,
} from "@/models/commercialData/clear/ClearIdConfirmBusiness";

defineProps<{
  section?: DocumentRetrieval;
}>();

const isOpen = ref(true);
</script>
